import React, { useEffect, useState } from 'react';

import { Box } from '../../../../../Box';
import { Skeleton } from '../../../../../Skeleton';
import { ImageFailed } from '../../../ui';

interface ImageComponentProps {
  alt: string;
  src: string;
  maxHeight: string;
  minHeight: string;
  width: string;
  hasError: boolean;
}

export const ImageComponent = ({
  alt,
  src,
  minHeight,
  maxHeight,
  width,
  hasError = false,
}: ImageComponentProps) => {
  const [loadedImage, setLoadedImage] = useState<{
    loading: boolean;
    fulfilled: boolean;
    rejected: boolean;
  }>({
    loading: true,
    fulfilled: false,
    rejected: false,
  });

  useEffect(() => {
    if (!src) return;

    const preloadImage = (url: string) => {
      const img = new Image();
      img.src = url;

      img.onloadstart = () => {
        setLoadedImage(() => ({
          loading: true,
          fulfilled: false,
          rejected: false,
        }));
      };
      img.onload = () => {
        setLoadedImage(() => ({
          loading: false,
          fulfilled: true,
          rejected: false,
        }));
      };
      img.onerror = () => {
        setLoadedImage(() => ({
          loading: false,
          fulfilled: false,
          rejected: true,
        }));
      };
    };

    // Предзагружаем изображение
    preloadImage(src);
  }, [src]);

  if (loadedImage.fulfilled) {
    return (
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor={loadedImage.fulfilled ? 'bg.dark.primary' : 'bg.light.primary'}
        maxWidth={width}
        width="100%"
        overflow="hidden"
        radius="m"
      >
        <img
          src={src}
          alt={alt}
          style={{
            maxWidth: width,
            maxHeight,
            minHeight,
            objectFit: 'contain',
          }}
        />
      </Box>
    );
  }

  if (loadedImage.rejected || hasError) {
    return <ImageFailed height={maxHeight} width={width} variant="one" />;
  }

  return <Skeleton height={maxHeight} width={width} variant="rect" />;
};
